//components
import {
  Kicker,
  KickerDot,
  SectionTitle,
  Grad,
} from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//data
import { agents, stages } from '../../agents';

//styles
import {
  LineupSection,
  Life,
  Row,
  Stage,
  StageCount,
  StageCountValue,
  StageName,
  AgentLink,
  Bridge,
} from './Lineup.styles';

// The map of the eleven agents by lifecycle stage. Every link jumps to its
// place in "What we automate" just below.
export function Lineup() {
  return (
    <LineupSection id="lineup">
      <Container>
        <Kicker>
          <KickerDot />
          The lineup
        </Kicker>
        <SectionTitle style={{ maxWidth: 'none' }}>
          11 agents. <Grad>One freight lifecycle.</Grad>
        </SectionTitle>

        <Life>
          <Row>
            {stages.map((stage, index) => (
              <Stage key={stage.id}>
                <StageCount href={`#stage-${stage.id}`}>
                  <StageCountValue>{stage.slugs.length}</StageCountValue>
                  <small>agents</small>
                </StageCount>
                <StageName>{stage.label}</StageName>
                {stage.slugs.map((slug) => (
                  <AgentLink key={slug} href={`#agent-${slug}`}>
                    {agents[slug].title}
                  </AgentLink>
                ))}
                {index === stages.length - 1 && (
                  <AgentLink href="#custom" $custom>
                    + Custom
                  </AgentLink>
                )}
              </Stage>
            ))}
          </Row>
        </Life>

        <Bridge>
          <span />
          What each one does, and what it&rsquo;s worth &darr;
          <span />
        </Bridge>
      </Container>
    </LineupSection>
  );
}
